export class THQ{
  Id : number;
  THQId:number
  Name: any;
  Type: any;
  TehsilName:string;
  Contact : string;
  Address : string;
  DistrictId : number;
  DistrictName:string;
  ReferedPatients:number=0;
  UserName : string;
  Password : string;
  IsActive:boolean;
  Phone:any
}
export class Tehsil{
  Id: number;
  TehsilName:string; 
}
export class THQ1{
  THQId: number;
   IsActive:boolean; 
Name :any;
Contact :any;
Address:any;
DistrictId: number;
}